import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const MatchPeople: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.37261 14.4356C7.20047 14.4356 8.68224 12.9532 8.68224 11.1246C8.68224 9.29599 7.20047 7.8136 5.37261 7.8136C3.54476 7.8136 2.06299 9.29599 2.06299 11.1246C2.06299 12.9532 3.54476 14.4356 5.37261 14.4356Z"
        fill="currentColor"
      />
      <path
        d="M15.6275 6.62202C17.4553 6.62202 18.9371 5.13963 18.9371 3.31101C18.9371 1.48239 17.4553 0 15.6275 0C13.7996 0 12.3179 1.48239 12.3179 3.31101C12.3179 5.13963 13.7996 6.62202 15.6275 6.62202Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.5356 15.3821C19.5356 14.9777 19.8646 14.6505 20.2678 14.6505C20.672 14.6505 21 14.9796 21 15.384L20.9971 18.316C20.9951 19.7977 19.7943 20.999 18.3123 20.999H12.9407C12.5365 20.999 12.2085 20.6708 12.2085 20.2665C12.2085 19.8621 12.5365 19.534 12.9407 19.534H18.3123C18.9859 19.534 19.5317 18.988 19.5326 18.3141L19.5356 15.3821Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.46932 5.61701C1.46932 6.02137 1.14033 6.34858 0.736143 6.34858C0.331959 6.34858 0.00488281 6.01945 0.00488281 5.6151L0.00783083 2.68305C0.00878797 1.20134 1.21058 0 2.69259 0H10.0118C10.416 0 10.744 0.328171 10.744 0.732524C10.744 1.13688 10.416 1.46505 10.0118 1.46505H2.69259C2.01895 1.46505 1.47322 2.011 1.47223 2.68496L1.46932 5.61701Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.54353 14.0078C9.87715 14.9865 10.7441 16.5658 10.7441 18.3454C10.7441 19.1062 10.2647 19.7694 9.38314 20.2255C8.4098 20.7295 6.89265 20.999 5.37254 20.999C3.85148 20.999 2.33433 20.7295 1.36095 20.2255C0.479378 19.7694 0 19.1062 0 18.3454C0 16.5658 0.866946 14.9865 2.20056 14.0078C2.9855 14.8712 4.11604 15.4123 5.37254 15.4123C6.62805 15.4123 7.75955 14.8713 8.54353 14.0078Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.7994 6.19421C20.133 7.17287 21 8.75221 21 10.5317C21 11.2926 20.5206 11.9557 19.639 12.4118C18.6657 12.9158 17.1485 13.1854 15.6274 13.1854C14.1073 13.1854 12.5901 12.9158 11.6168 12.4118C10.7352 11.9557 10.2559 11.2925 10.2559 10.5317C10.2559 8.75217 11.1228 7.17283 12.4564 6.19421C13.2404 7.05762 14.3719 7.59871 15.6274 7.59871C16.8839 7.59871 18.0145 7.05762 18.7994 6.19421Z"
        fill="currentColor"
      />
    </svg>
  )
})

MatchPeople.displayName = 'MatchPeople'
